<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9dW09f/tc-custom/9781454940760.jpg?1704515994916" alt="This image is the cover for the book Cooking with Cannabis, Cannabis Wellness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cooking with Cannabis, Cannabis Wellness
      </h1>
      <p class="bookDescription body article font2">
        <b>The award–winning culinary herbalist shows how easy, safe, and delicious it is to cook with cannabis—with the help of her unique, foolproof dosing chart.</b><br/><br/>This cookbook makes it easy to master the art of cooking and baking with cannabis! More than 100 recipes feature a spectrum of single-serve dishes, from healthy to decadent, all of which include raw or decarboxylated cannabis (a heating process that converts THCA into psychoactive THC). Plenty of practical information covers key issues such as extracting the maximum benefit from cannabis, dosing, and infusing with cannabis, as well as tips for first-time users who wish to safely make delicious cannabis edibles. Every serving delivers 5mg THC, just the right amount to experience both the recreational and gustatory pleasures of cannabis. There are so many delicious choices for every meal—Canna-Pancakes or a Mini Quiche with Arugula &amp; Smoked Salmon for breakfast, for example, or a Black Bean Burger or Asparagus-Stuffed Mushrooms for later in the day. You’ll also find innovative riffs on popular snacks, like hummus and tostadas, along with a stellar list of desserts, including Grilled Bananas with Canna-Honey, Savory Pears, and Chocolate Truffles.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pat Crocker
      </h2>
      
      <p class="authorDescription body article">Teacher, photographer, and author of 22 cookbooks, Pat Crocker is first and foremost a culinary herbalist with more than 1.25 million books in print. She was honored twice by the International Herb Association's Professional Award for outstanding contributions to the Herb Industry, and also received the 2009 Gertrude H. Foster award from the Herb Society of America for Excellence in Herbal Literature. Her books, The Juicing Bible and The Vegan Cook's Bible, have won "Best in the World" awards from the International Gourmand Culinary Guild. Crocker has been growing, photographing, teaching, and writing about herbs, herb gardens, food, and healthy diets for more than two decades. She is the author of The Herbalist’s Kitchen. She lives in Neustadt, Ontario, Canada. To learn more about her, visit patcrocker.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b17ad60